import type { Messages } from "./types";

export const ja = {
	meta: {
		indexTitle: "GSplat Share | Gaussian Splattingデータをリンクで共有",
		indexDescription:
			"Gaussian Splattingの3Dデータをアップロードして、リンクで共有できます。受け取った相手はブラウザで閲覧できます。PLY・SPZ・SOG・SuperSplat HTMLに対応しています。",
		aboutTitle: "サービスについて - GSplat Share",
		aboutDescription: "GSplat Shareは、Gaussian Splattingデータをブラウザで開ける共有リンクにするサービスです。",
		viewerTitle: "GSplat - 3D Gaussian Splatting Viewer",
		viewerDescription: "ブラウザで開ける3D Gaussian Splattingビューアです。",
	},
	nav: {
		main: "メインメニュー",
		howItWorks: "使い方",
		formats: "対応形式",
		about: "サービスについて",
		dashboard: "リンク管理",
		login: "Googleでログイン",
		upload: "アップロード",
	},
	footer: {
		tagline: "Gaussian Splattingデータをリンクで共有。",
		about: "サービスについて",
		terms: "利用規約",
		privacy: "プライバシーポリシー",
		contact: "お問い合わせ",
	},
	upload: {
		introTitle: "Gaussian Splattingを、\nリンクで共有。",
		introDescription:
			"PLY・SPZ・SOGファイルをアップロードすると、ブラウザで見られる共有リンクを作成できます。ビューアを自分で用意する必要はありません。",
		panelLabel: "まずはファイルを選択",
		studioLabel: "Gaussian Splattingデータの共有サービス",
		flowChoose: "ファイルを選ぶ",
		flowPreview: "共有内容を設定",
		flowShare: "リンクを共有",
		titleInvalid: "タイトルを1〜100文字で入力してください。",
		descriptionLimit: "説明は{{max}}文字以内で入力してください。",
		descriptionCount: "{{count}} / {{max}}文字",
		passwordInvalid: "パスワードは3〜200文字で入力してください。",
		workspaceTitle: "共有リンクを作成",
		workspaceDescription: "ファイルを選んだあとに、タイトル・公開期限・最初に表示する視点を設定できます。",
		inProgress: "送信中",
		unsaved: "未保存の変更",
		notUploaded: "まだ送信していません",
		offlineHint: "ファイルと設定は残っています。インターネットに接続してからアップロードしてください。",
		selectionFailed: "ファイルを選び直してください",
		sizeError: "ファイルサイズは最大2 GBです。容量を減らしてから選び直してください。",
		emptyFile: "このファイルは空です。データのあるファイルを選択してください。",
		changeFile: "ファイルを変更",
		removeFile: "ファイル選択を取り消す",
		previewTitle: "プレビュー",
		previewHint: "プレビューで表示を確認できます。確認せずに共有リンクを作成することもできます。",
		largePreviewHint: "ファイルサイズが大きいため、プレビューは自動で表示しません。表示には端末のメモリを使用します。",
		linkHint: "リンクを知っている人が閲覧できます。必要に応じてパスワードを設定してください。",
		discardTitle: "変更を破棄しますか？",
		discardDescription: "この画面の未保存の設定は失われます。",
		discardTransfer: "アップロードを中止して、この画面から移動します。",
		discardHint: "この後にアップロードするには、ファイルを選び直してください。",
		keepEditing: "この画面に戻る",
		discard: "破棄して続ける",
		newFile: "別のファイルを共有",
		helpTitle: "共有する前に確認したいこと",
		helpSteps:
			"1. ファイルを選択 → 2. タイトル・期限を設定 → 3. 送信完了後にリンクをコピー。表示する最初の視点もプレビューから設定できます。",
		helpFormats: "PLY・SPZ・SOG・HTMLに対応。最大2 GB。",
		helpAccount:
			"ログイン中に作成したリンクは「リンク管理」で確認・編集できます。ログインせずに作成したリンクは、画面を閉じる前にコピーして保存してください。",
		previewError: "このブラウザでプレビューを表示できませんでした",
		previewErrorHint:
			"ファイルの形式や、この端末の描画機能・メモリが原因の可能性があります。まだサーバーには送信していません。再表示するか、SuperSplatなどでファイルを確認してください。",
		retryPreview: "プレビューを再表示",
		title: "ファイルをアップロード",
		description: "PLY・SPZ・SOG・SuperSplat HTMLに対応。",
		dropHere: "ファイルをここにドロップするか",
		orSelect: "または",
		selectFile: "ファイルを選択",
		hint: "1ファイル最大2 GB",
	},
	share: {
		instruction: "リンクをコピーして、メールやチャットで相手に送ってください。",
		saveHint:
			"ログインせずに作成したリンクは、画面を閉じる前にコピーして保存してください。リンク管理には表示されません。",
		title: "共有リンクを作成しました",
		copy: "リンクをコピー",
		copied: "コピーしました",
		openViewer: "3Dデータを見る",
		manage: "リンク管理",
	},
	about: {
		title: "サービスについて",
		subtitle: "Gaussian Splattingデータをブラウザで共有できるサービスです。",
		intro:
			"GSplat Shareは、Gaussian Splattingの3Dデータをリンクで共有できるサービスです。ファイルをアップロードしてリンクを送れば、相手はアプリをインストールせずに閲覧できます。制作途中の確認や、完成した作品の紹介にお使いください。",
		featuresTitle: "GSplat Shareでできること",
		features: [
			{ label: "PLY / SPZ / SOG", desc: "：Gaussian Splattingデータをアップロードして共有できます。" },
			{ label: "SuperSplat HTML", desc: "：書き出したHTMLをアップロードして共有できます。" },
			{ label: "パスワード保護", desc: "：閲覧時にパスワードの入力を求められます。" },
			{ label: "公開期限", desc: "：1時間・1日・1週間・無期限から選べます。" },
			{ label: "ブラウザビューア", desc: "：専用アプリをインストールせずに閲覧できます。" },
		],
		superSplatTitle: "SuperSplatで作ったデータを共有する",
		superSplatSteps: [
			"でシーンを編集",
			"からHTMLを書き出す",
			"書き出したHTMLをGSplat Shareにアップロード",
			"共有リンクをコピーして相手に送る",
		] as [string, string, string, string],
		superSplatEditor: "SuperSplat エディタ",
		creatorTitle: "運営者",
		creatorBio:
			"Ryuto Hagaが個人で開発・運営しています。3Dデータをもっと気軽に見せ合えるように、このサービスをつくっています。",
	},
	uploadModal: {
		errorUncertain: "サーバーでの完了を確認できませんでした",
		recoveryUncertainSave:
			"保存処理は完了している可能性があります。ログイン中は共有リンク一覧を確認してから再試行してください。再送するとファイルが重複する場合があります。",
		recoveryUncertainLink:
			"リンクが作成済みの可能性があります。ログイン中は共有リンク一覧を先に確認してください。再試行では送信済みファイルを再利用しますが、リンクが重複する場合があります。",
		stageWaiting: "送信済みデータの確認を待っています",
		errorOffline: "インターネット接続が切れているようです",
		recoveryOffline:
			"Wi-Fiやモバイル回線の接続を確認してから、もう一度送信してください。ファイルと設定は残っています。",
		errorNetwork: "サーバーに接続できませんでした",
		recoveryNetwork:
			"回線またはサーバーとの通信が途切れた可能性があります。他のサイトが開くか確認し、少し待って再試行してください。",
		errorTimeout: "サーバーからの応答に時間がかかっています",
		recoveryTimeout:
			"通信の遅延やサーバーの混雑が考えられます。回線を確認して再試行してください。繰り返す場合は時間をおいてお試しください。",
		errorServer: "サーバー側で処理に失敗しました",
		recoveryServer: "少し待ってから、もう一度アップロードしてください。繰り返し失敗する場合は、お問い合わせください。",
		errorBusy: "リクエストが集中しています",
		recoveryBusy: "しばらく待ってから再試行してください。ファイルと設定は残っています。",
		errorFile: "ファイルまたは入力内容を確認してください",
		recoveryFile:
			"対応形式（PLY・SPZ・SOG・HTML）、2 GB以下の容量、空でないファイルか確認してください。タイトルやパスワードも見直して再試行してください。",
		errorPermission: "アップロードの権限を確認できませんでした",
		recoveryPermission:
			"ログイン状態を確認してください。ログインし直す場合はファイルと設定を控えてから、再試行してください。",
		errorUnknown: "アップロードを完了できませんでした",
		recoveryUnknown:
			"原因を特定できませんでした。ファイルと設定は残っています。再試行しても続く場合は、お問い合わせください。",
		stagePreparing: "アップロードを準備しています",
		stageSending: "ファイルを送信しています",
		stageFinalizing: "送信が完了し、ファイルを保存しています",
		stageLink: "共有リンクを作成しています",
		optionalSettings: "説明・パスワードを追加する（任意）",
		cancelTransfer: "送信を中止",
		cancelled: "アップロードを中止しました。",
		retryHint: "ファイルは選択したままです。確認してもう一度お試しください。",
		progressNote:
			"送信が終わると、ファイルの保存とリンクの作成が始まります。完了するまでこの画面を開いたままお待ちください。",
		title: "共有リンクを作成",
		subtitle: "タイトルと公開期限を設定してください。必要に応じて、説明やパスワードも追加できます。",
		showPreview: "プレビューを表示",
		hidePreview: "プレビューを閉じる",
		expandPreview: "プレビュー拡大",
		shrinkPreview: "プレビュー縮小",
		adjustInitialCamera: "最初に表示する視点",
		adjustInitialCameraDesc: "プレビューを操作して、リンクを開いたときに表示する位置と向きを選んでください。",
		cameraPoseLocked: "開始視点を設定しました",
		cameraPoseUnlock: "開始視点を自動に戻す",
		setCameraPoseAsDefault: "この視点を開始視点として保存",
		centerCalculationMethod: "中心位置の算出方法",
		centerCalculationRobust: "オブジェクト中心 (推奨)",
		centerCalculationOrigin: "原点 (0,0,0)",
		centerCalculationAabb: "全体の境界ボックス",
		max: "最大",
		overLimit: "容量上限を超えています",
		settingsLegend: "基本情報",
		titleLabel: "タイトル",
		titlePlaceholder: "例: 住宅外観スキャン / 展示会ブース案",
		descriptionLabel: "説明",
		descriptionPlaceholder: "共有先に伝えたい補足があれば入力してください",
		expirationLabel: "公開期限",
		securityLegend: "閲覧の設定",
		passwordProtection: "パスワード保護",
		passwordProtectionDesc: "リンクの閲覧をパスワードで制限します",
		passwordLabel: "パスワード",
		passwordPlaceholder: "3文字以上で入力",
		showPassword: "パスワードを表示",
		hidePassword: "パスワードを隠す",
		passwordGood: "設定できます",
		passwordTooShort: "短すぎます",
		passwordNote: "ビューアを開く際に、このパスワードが必要です。",
		errorCode: "エラーコード: {{code}}",
		uploading: "アップロード中…",
		saving: "保存中…",
		sending: "送信中…",
		remainingHours: "残り {{hours}}時間 {{minutes}}分",
		remainingMinutes: "残り {{minutes}}分 {{seconds}}秒",
		remainingSeconds: "残り {{seconds}}秒",
		cancel: "キャンセル",
		submit: "共有リンクを作成",
		processing: "処理中…",
		expiration: {
			hour: "1時間（{{time}} に期限切れ）",
			day: "1日（{{date}} に期限切れ）",
			week: "1週間（{{date}} に期限切れ）",
			unlimited: "無期限",
		},
	},
	viewer: {
		fullscreenUnavailable: "このブラウザでは全画面にできません。",
		renderError: "この3Dデータを表示できませんでした",
		touchHint: "指で視点を変更 · 足あとボタンで歩行",
		downloadManifest: "マニフェストをダウンロード",
		manifestHint: "LOD配信で読み込むファイルを指定した参照ファイルです。3Dデータ本体は含まれません。",

		fullscreen: "全画面",
		exitFullscreen: "全画面を終了",
		download: "ダウンロード",
		refresh: "再読み込み",
		htmlError: "コンテンツを読み込めませんでした",

		exploreHint: "マウス・キーボードで視点を変更 · 足あとボタンで歩行",
		share: "リンクを共有",
		linkCopied: "コピー済み",
		copyFallback: "このリンクを選択してコピーしてください。",
		uploadOwn: "自分の3Dデータも共有する",

		notFound: "ファイルが見つかりません",
		notFoundWithError: "ファイルが見つかりません: {{message}}",
		apiUnavailable: "サーバーに接続できませんでした",
		apiUnavailableHint: "しばらくしてからもう一度お試しください。時間をおいても開けない場合は、お問い合わせください。",
		passwordProtected: "このモデルはパスワードで保護されています。",
		passwordTitle: "パスワード保護",
		passwordDesc: "このモデルはパスワードで保護されています。閲覧するにはパスワードを入力してください。",
		passwordPlaceholder: "パスワードを入力",
		passwordIncorrect: "パスワードが正しくありません。もう一度お試しください。",
		verifying: "照合中…",
		showModel: "モデルを表示",
		loading: "3Dモデルを読み込み中",
		close: "閉じる",
		details: "詳細",
		format: "形式",
		size: "ファイルサイズ",
		views: "閲覧数",
		expires: "公開期限",
		promo: "Gaussian Splattingデータをリンクで共有。",
		upload: "アップロード",
	},
	shareButton: {
		copyUrl: "URLをコピー",
		shareOnX: "Xで共有",
		embed: "埋め込み",
		copied: "クリップボードにコピーしました。",
		embedTitle: "埋め込みコード",
		copyCode: "コードをコピー",
	},
	loadingOverlay: {
		title: "アップロード中",
		subtitle: "共有リンクを準備しています。",
	},
	notFound: {
		code: "404",
		title: "ページが見つかりません",
		description: "URLをご確認ください。",
		backHome: "トップへ戻る",
	},
	error: {
		recovery: "画面を読み込めませんでした。再読み込みするか、トップへ戻ってもう一度お試しください。",
		title: "エラーが発生しました",
		reload: "ページを再読み込み",
		unknown: "不明なエラー",
	},
	alerts: {
		fileTooLarge: "ファイルサイズが上限（{{max}}MB）を超えています",
		fileTooLargeRetry: "ファイルサイズが大きすぎます。小さいファイルでお試しいただくか、お問い合わせください。",
		fileTooLargeSimple: "ファイルサイズが大きすぎます。小さいファイルをアップロードしてください。",
		unsupportedFile: "対応しているファイル（.html、.ply、.spz、.sog）を選択してください。",
		shareSaveFailed:
			"アップロードは完了しましたが、共有リンクの保存に失敗しました。時間をおいてもう一度お試しください。",
		uploadFailed: "アップロードに失敗しました。もう一度お試しください。",
		uploadFailedWithMessage: "アップロードに失敗しました: {{message}}",
	},
	language: {
		switch: "言語",
		ja: "日本語",
		en: "English",
	},
} satisfies Messages;
